
// Section with Editor
$(document).on('shopify:section:load', function(e){ 
  $('#' + e.target.id).find('[data-section]').sectionJs();
}).ready(function() {
  $('[data-section]').each(function(){ $(this).sectionJs() });
});

$.fn.sectionJs = function(){
  var $this = this;
  if($this.data('section') == "Slider") {
    $this.Slider();
  }else if($this.data('section') == "ProductCarousel") {
    $this.ProductCarousel();
  }else if($this.data('section') == "TestimonialSection") {
    $this.TestimonialSection();
  }else if($this.data('section') == "AboutInfo") {
    $this.AboutInfo();
  }else if($this.data('section') == "HeaderSection") {
    $this.HeaderSection();
  }else if($this.data('section') == "MasonryMultipleBanner") {
    $this.MasonryMultipleBanner();
  }else if($this.data('section') == "MultipleBanner") {
    $this.MultipleBanner();
  }else if($this.data('section') == "FeaturedProduct") {
    $this.FeaturedProduct();
  }else if($this.data('section') == "MasonryProduct") {
    $this.MasonryProduct();
  }else if($this.data('section') == "TabWithProduct") {
    $this.TabWithProduct();
  }else if($this.data('section') == "LatestBlog") {
    $this.LatestBlog();
  }else if($this.data('section') == "brandLogo") {
    $this.brandLogo();
  }else if($this.data('section') == "TeamMember") {
    $this.TeamMember();
  }else if($this.data('section') == "CollectionTemplate") {
    $this.CollectionTemplate();
  }else if($this.data('section') == "CollectionListTemplate") {
    $this.CollectionListTemplate();
  }else if($this.data('section') == "ListCollectionTemplate") {
    $this.ListCollectionTemplate();
  }else if($this.data('section') == "BlogTemplate") {
    $this.BlogTemplate();
  }else{}   
}

// Slideshow active js
$.fn.Slider = function() {
  /*-----------------------------------------------
  15. Home Slider
-------------------------------------------------*/
  $('.slider__activation__wrap').owlCarousel({
    loop: true,
    margin:0,
    nav:true,
    rtl:true,
    autoplay: true,
    navText: [ '<i class="zmdi zmdi-chevron-left"></i>', '<i class="zmdi zmdi-chevron-right"></i>' ],
    autoplayTimeout: 10000,
    items:1,
    dots: false,
    lazyLoad: true,
    autoplay: false,
    responsive:{
      0:{
        items:1
      },
      600:{
        items:1
      },
      800:{
        items:1
      },
      1024:{
        items:1
      },
      1200:{
        items:1
      },
      1400:{
        items:1
      },
      1920:{
        items:1
      }
    }
  });
  $("img.lazyload").lazyload();
};

// Featured product with carousel active js
$.fn.ProductCarousel = function() {
  $('.popular__product__wrap').slick({
    speed: 700,
    arrows: true,
    dots: false,
    slidesToScroll: 1,
    prevArrow: '<i class="zmdi zmdi-chevron-left"></i>',
    nextArrow: '<i class="zmdi zmdi-chevron-right"></i>'
  });
  $("img.lazyload").lazyload();
};

// Testimonial active js
$.fn.TestimonialSection = function() {
  /*-----------------------------------------------
  17. Testimonial Wrap
-------------------------------------------------*/
  $('.testimonial__wrap').owlCarousel({
    loop: true,
    margin:0,
    nav:false,
    rtl:true,
    autoplay: false,
    navText: false,
    autoplayTimeout: 10000,
    items:1,
    dots: false,
    lazyLoad: true,
    responsive:{
      0:{
        items:1
      },
      600:{
        items:1
      },
      800:{
        items:1
      },
      1024:{
        items:1
      },
      1200:{
        items:1
      },
      1400:{
        items:1
      },
      1920:{
        items:1
      }
    }
  });
  $("img.lazyload").lazyload();
};

// About Info active js
$.fn.AboutInfo = function() {
  $('.video-popup').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    zoom: {
      enabled: true,
    }
  });
};

// Header active js
$.fn.HeaderSection = function() {
  /*-------------------------------------------
  04. Sticky Header
--------------------------------------------- */ 
  var win = $(window);
  var sticky_id = $("#sticky-header-with-topbar");
  win.on('scroll',function() {    
    var scroll = win.scrollTop();
    if (scroll < 245) {
      sticky_id.removeClass("scroll-header");
    }else{
      sticky_id.addClass("scroll-header");
    }
  });

  /*------------------------------------    
  09. Search Bar
--------------------------------------*/ 
  $( '.search__open' ).on( 'click', function () {
    $( 'body' ).toggleClass( 'search__box__show__hide' );
    return false;
  });

  $( '.search__close__btn .search__close__btn_icon' ).on( 'click', function () {
    $( 'body' ).toggleClass( 'search__box__show__hide' );
    return false;
  });


  /*------------------------------------    
  10. Toogle Menu
--------------------------------------*/
  $('.toggle__menu').on('click', function() {
    $('.offsetmenu').addClass('offsetmenu__on');
    $('.body__overlay').addClass('is-visible');

  });

  $('.offsetmenu__close__btn').on('click', function() {
    $('.offsetmenu').removeClass('offsetmenu__on');
    $('.body__overlay').removeClass('is-visible');
  });

  /*------------------------------------    
  11. Shopping Cart Area
--------------------------------------*/
  $('.cart__menu').on('click', function() {
    $('.shopping__cart').addClass('shopping__cart__on');
    $('.body__overlay').addClass('is-visible');

  });

  $('.offsetmenu__close__btn').on('click', function() {
    $('.shopping__cart').removeClass('shopping__cart__on');
    $('.body__overlay').removeClass('is-visible');
  });
  
   /* Mega Menu */	
	$('.megamenu-li').parent('ul').addClass('mega_dropdown');
	$('.mega_dropdown').parent('li').addClass('mega-menu-drop');
  
  
  /*------------------------------------    
  12. Filter Area
--------------------------------------*/

  $('.filter__menu').on('click', function() {
    $('.filter__wrap').addClass('filter__menu__on');
    $('.body__overlay').addClass('is-visible');

  });

  $('.filter__menu__close__btn').on('click', function() {
      $('.filter__wrap').removeClass('filter__menu__on');
      $('.body__overlay').removeClass('is-visible');
  });



/*------------------------------------    
  13. User Menu
--------------------------------------*/

  $('.user__menu').on('click', function() {
    $('.user__meta').addClass('user__meta__on');
    $('.body__overlay').addClass('is-visible');

  });

  $('.offsetmenu__close__btn').on('click', function() {
      $('.user__meta').removeClass('user__meta__on');
      $('.body__overlay').removeClass('is-visible');
  });



/*------------------------------------    
  14. Overlay Close
--------------------------------------*/
  $('.body__overlay').on('click', function() {
    $(this).removeClass('is-visible');
    $('.offsetmenu').removeClass('offsetmenu__on');
    $('.shopping__cart').removeClass('shopping__cart__on');
    $('.filter__wrap').removeClass('filter__menu__on');
    $('.user__meta').removeClass('user__meta__on');
  });
  
  /* Remove Attr */
  	$('.offsetmenu__close__btn a').removeAttr('href');
    $('.filter__box a, .filter__menu__close__btn a').removeAttr('href'); 

};

// Masonry Multiple Banner active js
$.fn.MasonryMultipleBanner = function() {
  $("img.lazyload").lazyload();
};

// Multiple Banner active js
$.fn.MultipleBanner = function() {
  $("img.lazyload").lazyload();
};

// Featured active js
$.fn.FeaturedProduct = function() {
  $("img.lazyload").lazyload();
};

// Masonry Product active js
$.fn.MasonryProduct = function() {
  $("img.lazyload").lazyload();
};

// Tab With Product active js
$.fn.TabWithProduct = function() {
  $("img.lazyload").lazyload();
};

// Latest Blog active js
$.fn.LatestBlog = function() {
  $("img.lazyload").lazyload();
};

// Brand Logo active js
$.fn.brandLogo = function() {
  $("img.lazyload").lazyload();
};

// Team Member active js
$.fn.TeamMember = function() {
  $("img.lazyload").lazyload();
};

// Collection Template active js
$.fn.CollectionTemplate = function() {
  $("img.lazyload").lazyload();
};

// Collection List Template active js
$.fn.CollectionListTemplate = function() {
  $("img.lazyload").lazyload();
};

// List Collection Template active js
$.fn.ListCollectionTemplate = function() {
  $("img.lazyload").lazyload();
};

// Blog Template active js
$.fn.BlogTemplate = function() {
  $("img.lazyload").lazyload();
};




(function($) {
    "use strict";

	jQuery(document).ready(function(){
    


/*-------------------------------------------
  02. wow js active
--------------------------------------------- */

  new WOW().init();




/*--------------------------
  05. ScrollUp
---------------------------- */
$.scrollUp({
    scrollText: '<i class="zmdi zmdi-chevron-up"></i>',
    easingType: 'linear',
    scrollSpeed: 900,
    animation: 'fade'
});



/*---------------------------
  06. Tooltip
------------------------------*/    
$('[data-toggle="tooltip"]').tooltip({
    animated: 'fade',
    placement: 'top',
    container: 'body'
});



/*-----------------------------------
  07. ScrollReveal Js Init
-------------------------------------- */

  window.sr = ScrollReveal({ duration: 800 , reset: true });
    sr.reveal('.foo');
    sr.reveal('.bar');


/*--------------------------------
  18. Magnific Popup
----------------------------------*/

$('.image-popup').magnificPopup({
  type: 'image',
  mainClass: 'mfp-fade',
  removalDelay: 100,
  gallery:{
      enabled:true, 
  }
});


/*-------------------------------
  20.  Plus Minus Button 
--------------------------------*/
    $(".cart-plus-minus").append('<div class="dec qtybutton">-</i></div><div class="inc qtybutton">+</div>');

    $(".qtybutton").on("click", function () {
        var $button = $(this);
        var oldValue = $button.parent().find("input").val();
        if ($button.text() == "+") {
            var newVal = parseFloat(oldValue) + 1;
        } else {
            // Don't allow decrementing below zero
            if (oldValue > 1) {
                var newVal = parseFloat(oldValue) - 1;
            } else {
                newVal = 1;
            }
        }
        $button.parent().find("input").val(newVal);
    });


/*--------------------------
  21. jQuery scroll Nav
---------------------------- */
    $('.onepage--menu').onePageNav({
        scrollOffset: 0
    }); 		

	 	

	/* preloader */
    $(window).on('load', function() {
      $('#preloader_active').fadeOut('slow');
    }); 
      
      
    /* Match Heigh   
    $(function() {
		$('.product__list .tab-pane > div').matchHeight();
    });  
    $(function() {
		$('.best__product__list > div').matchHeight();
    }); 
    $(function() {
		$('.blog__wrap.latest-blog > div').matchHeight();
    });
    $(function() {
		$('.blog__wrap > .row > div').matchHeight();
    });
    $(function() {
		$('.shop__page .product__list > div').matchHeight();
    }); 
    
    */
      
    });

})(jQuery);



